module.exports = __webpack_public_path__ + "static/media/persona-sketches-full.21655e85.png";